/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["p-inputMask[_ngcontent-%COMP%]{margin-right:-2px;width:100%}p-inputMask[_ngcontent-%COMP%]     .ui-inputtext{height:23px}  .ui-overlaypanel-content{padding:0}"];
export { styles as styles };
